var that;
import QrcodeVue from 'qrcode.vue'
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },
    //导入组件
    components: {
        QrcodeVue,
    },
    data() {
        return {
            memberId: '',
            timer: null,
            show: false,
            qcsize: 200,
            qrCode123: '',
            dhrecordList: [

            ]
        };
    },

    created() {
        that = this;
        this.memberId = this.$route.query.memberId;
        this.getSuccessCouponList();
    },

    mounted() {

        if (this.show == false) {
            clearInterval(this.timer);
        }

    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },
    methods: {


        // 列表接口
        getSuccessCouponList() {
            this.$api.getSuccessCouponList({
                params: {
                    memberId: this.$route.query.memberId,
                },
                success: function(res) {
                    console.log("resres1111", res);
                    that.dhrecordList = res.data
                }
            })
        },

        //出示兑换码
        showDhCode(val) {
            this.show = true;
            this.qrCode123 = val;
            // 定时任务  3-5s刷新
            this.timer = setInterval(() => {
                this.isWriteOff(val);
            }, 3000);

        },
        // 消费券是否核销过
        isWriteOff(val) {
            this.$api.isWriteOff({
                params: {
                    dhCode: val,
                },
                success: function(res) {
                    console.log("isWriteOff", res);
                    // 核销状态 0： 未核销 1： 已核销
                    if (res.data == 1) {
                        location.reload();
                        clearInterval(this.timer);
                    } else {
                        this.show = true;
                    }

                }
            })
        },
        // 点击遮罩事件
        closeDialog() {
            console.log("点击遮罩");
            clearInterval(this.timer);
        }
    }
};